import { render, staticRenderFns } from "./VIPSetting.vue?vue&type=template&id=20e7fe0c&"
import script from "./VIPSetting.vue?vue&type=script&lang=js&"
export * from "./VIPSetting.vue?vue&type=script&lang=js&"
import style0 from "./VIPSetting.vue?vue&type=style&index=0&id=20e7fe0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports